import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDocumentReceiveMethodOptions } from "../../../../axios/api/services";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  commonThunkCondition,
} from "@duosoftbg/nacid-components";

const sliceName = "appData/receiveResult";
const receiveResultSlice = createSlice({
  name: sliceName,
  initialState: initialThunkState([]),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(receiveResultThunk.pending, (state, action) => {
      return pendingThunkState(state);
    });
    builder.addCase(receiveResultThunk.fulfilled, (state, action) => {
      const { data } = action.payload;
      return fulfilledThunkState(data);
    });
    builder.addCase(receiveResultThunk.rejected, (state, action) => {
      return rejectedThunkState([]);
    });
  },
});

export const receiveResultThunk = createAsyncThunk(
  `${sliceName}/receiveResultThunk`,
  async () => {
    const response = await getDocumentReceiveMethodOptions()();
    return { data: response };
  },
  {
    condition: (_, { getState, extra }) => {
      return commonThunkCondition(getState()["AppData"]?.receiveResult);
    },
  },
);

export default receiveResultSlice.reducer;
